// extracted by mini-css-extract-plugin
export default {"message":"AccessDenied_message__IjLWW"};